import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useProfile } from "../../features/auth/hooks/useProfile";

const ALLOWED_NEW_USER_PATHS = ["/create-account", "/signup-complete"];

const AuthProtected = () => {
  const { user, token, loading, isNewUser } = useProfile();
  const { pathname } = useLocation();

  if (loading) {
    return null;
  }

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (isNewUser && !ALLOWED_NEW_USER_PATHS.includes(pathname)) {
    return <Navigate to="/create-account" replace />;
  }

  if (!isNewUser && pathname === "/create-account") {
    return <Navigate to="/locker-room" replace />;
  }

  return <Outlet />;
};

export default AuthProtected;
